import * as Str from './String'

export const Input = Str.Input
export const Output = Str.Output
